/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetFollowUpNecessityJudgmentResult200Response } from '../models';
/**
 * FollowUpNecessityJudgmentResultApi - axios parameter creator
 * @export
 */
export const FollowUpNecessityJudgmentResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 追客要否判断結果取得API
         * @summary 追客要否判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpNecessityJudgmentResult: async (callResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callResultId' is not null or undefined
            assertParamExists('getFollowUpNecessityJudgmentResult', 'callResultId', callResultId)
            const localVarPath = `/api/user/call_results/{callResultId}/transcription/follow_up_necessity_judgment_result`
                .replace(`{${"callResultId"}}`, encodeURIComponent(String(callResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 追客要否判断結果生成API
         * @summary 追客要否判断結果生成API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postJudgeFollowUpNecessity: async (callResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callResultId' is not null or undefined
            assertParamExists('postJudgeFollowUpNecessity', 'callResultId', callResultId)
            const localVarPath = `/api/user/call_results/{callResultId}/transcription/judge_follow_up_necessity`
                .replace(`{${"callResultId"}}`, encodeURIComponent(String(callResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FollowUpNecessityJudgmentResultApi - functional programming interface
 * @export
 */
export const FollowUpNecessityJudgmentResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FollowUpNecessityJudgmentResultApiAxiosParamCreator(configuration)
    return {
        /**
         * 追客要否判断結果取得API
         * @summary 追客要否判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFollowUpNecessityJudgmentResult(callResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFollowUpNecessityJudgmentResult200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFollowUpNecessityJudgmentResult(callResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 追客要否判断結果生成API
         * @summary 追客要否判断結果生成API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postJudgeFollowUpNecessity(callResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postJudgeFollowUpNecessity(callResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FollowUpNecessityJudgmentResultApi - factory interface
 * @export
 */
export const FollowUpNecessityJudgmentResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FollowUpNecessityJudgmentResultApiFp(configuration)
    return {
        /**
         * 追客要否判断結果取得API
         * @summary 追客要否判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpNecessityJudgmentResult(callResultId: number, options?: any): AxiosPromise<GetFollowUpNecessityJudgmentResult200Response> {
            return localVarFp.getFollowUpNecessityJudgmentResult(callResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * 追客要否判断結果生成API
         * @summary 追客要否判断結果生成API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postJudgeFollowUpNecessity(callResultId: number, options?: any): AxiosPromise<void> {
            return localVarFp.postJudgeFollowUpNecessity(callResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FollowUpNecessityJudgmentResultApi - interface
 * @export
 * @interface FollowUpNecessityJudgmentResultApi
 */
export interface FollowUpNecessityJudgmentResultApiInterface {
    /**
     * 追客要否判断結果取得API
     * @summary 追客要否判断結果取得API
     * @param {number} callResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpNecessityJudgmentResultApiInterface
     */
    getFollowUpNecessityJudgmentResult(callResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetFollowUpNecessityJudgmentResult200Response>;

    /**
     * 追客要否判断結果生成API
     * @summary 追客要否判断結果生成API
     * @param {number} callResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpNecessityJudgmentResultApiInterface
     */
    postJudgeFollowUpNecessity(callResultId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getFollowUpNecessityJudgmentResult operation in FollowUpNecessityJudgmentResultApi.
 * @export
 * @interface FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest
 */
export interface FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest {
    /**
     * 
     * @type {number}
     * @memberof FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResult
     */
    readonly callResultId: number
}

/**
 * Request parameters for postJudgeFollowUpNecessity operation in FollowUpNecessityJudgmentResultApi.
 * @export
 * @interface FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest
 */
export interface FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest {
    /**
     * 
     * @type {number}
     * @memberof FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessity
     */
    readonly callResultId: number
}

/**
 * FollowUpNecessityJudgmentResultApi - object-oriented interface
 * @export
 * @class FollowUpNecessityJudgmentResultApi
 * @extends {BaseAPI}
 */
export class FollowUpNecessityJudgmentResultApi extends BaseAPI implements FollowUpNecessityJudgmentResultApiInterface {
    /**
     * 追客要否判断結果取得API
     * @summary 追客要否判断結果取得API
     * @param {FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpNecessityJudgmentResultApi
     */
    public getFollowUpNecessityJudgmentResult(requestParameters: FollowUpNecessityJudgmentResultApiGetFollowUpNecessityJudgmentResultRequest, options?: AxiosRequestConfig) {
        return FollowUpNecessityJudgmentResultApiFp(this.configuration).getFollowUpNecessityJudgmentResult(requestParameters.callResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 追客要否判断結果生成API
     * @summary 追客要否判断結果生成API
     * @param {FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpNecessityJudgmentResultApi
     */
    public postJudgeFollowUpNecessity(requestParameters: FollowUpNecessityJudgmentResultApiPostJudgeFollowUpNecessityRequest, options?: AxiosRequestConfig) {
        return FollowUpNecessityJudgmentResultApiFp(this.configuration).postJudgeFollowUpNecessity(requestParameters.callResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
